import {updateContentSubmissionInCache} from '@/utils/cache-updaters/contentSubmissions';
import {
  CONTENT_SUBMISSION_ANALYSIS_STATUS,
  ContentSubmission,
} from '@/types/contentSubmission';
import type QueryContext from '@/api/QueryContext';
import contentSubmissionFetchers from '@/api/fetchers/contentSubmission';

/**
 * If the content submission's analysis is still processing,
 * re-fetch it from the API and update all cached query pages.
 */
async function refreshContentSubmissionIfProcessing(
  contentSubmission: ContentSubmission
) {
  if (
    contentSubmission.latestVersionAnalysisStatus !==
    CONTENT_SUBMISSION_ANALYSIS_STATUS.PROCESSING
  ) {
    return;
  }

  const response = (await contentSubmissionFetchers.contentSubmission({
    queryKey: ['contentSubmission', contentSubmission.id],
    meta: {contentSubmissionId: contentSubmission.id},
  } as QueryContext)) as unknown as {data: ContentSubmission};

  updateContentSubmissionInCache(contentSubmission.id, {
    latestVersionAnalysisStatus: response.data.latestVersionAnalysisStatus,
    latestVersionCampaignFitScore: response.data.latestVersionCampaignFitScore,
  });
}

export default refreshContentSubmissionIfProcessing;
